import React from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { Button, Flex, Typography } from "antd"
import styles from "./EmbeddedBooking.module.css"
import { routes } from "router"
import { BOOKING_MODES } from "pagesV2/pro/Bookings/constants"
import { selectedPaymentMethodIdSelector } from "store/user"
import { useTheme } from "context/AntdThemeContext"
import { Container } from "reactstrap"
import { useTranslation } from "react-i18next"
const { Text } = Typography

const EmbeddedBookingLayout = ({
  children,
  setActiveTab,
  activeTab,
  onNext,
  onPrevious,
  type,
  mode,
  selectedPaymentProvider,
  isNextDisabled,
  paymentLoading
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { uuid, id } = useParams()
  // Embedded (third-party widget) is always guest checkout, so the Next button must not wait
  // for a saved payment method selection even when a session exists in shared localStorage.
  const loggedIn = mode === BOOKING_MODES.embedded ? null : localStorage.getItem("access_token")
  const selectedPaymentMethodId = useSelector(selectedPaymentMethodIdSelector)
  const location = useLocation()
  const isGuideProfileBooking = location.pathname.includes("guide-profile/experience_booking")
  const { isSportsman } = useTheme()

  return (
    <Container>
      {children}
      <footer className={styles.footer}>
        <Flex align="center" justify="space-between" wrap gap={10} className={styles.footerContent}>
          {(!mode || mode === BOOKING_MODES.embedded) && (
            <a href="https://dspro.guide" target="_blank" rel="noopener noreferrer" className={styles.dsGuideLink}>
              <Text>
                {t("settings.powered_by")} {isSportsman ? t("select_adventure_mode.sportsman") : t("select_adventure_mode.sportswoman")}
              </Text>
            </a>
          )}
          {!type && (
            <Flex gap={8} className={styles.formButtons} wrap>
              {activeTab === 1 && !isGuideProfileBooking && (
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    if (mode === BOOKING_MODES.embedded) {
                      navigate(routes?.embeddedExperienceDetail({ uuid: uuid, id: id }))
                    } else {
                      navigate(routes?.tripPath({ id: id }))
                    }
                  }}
                >
                  Back to Experience Detail
                </Button>
              )}
              {activeTab > 1 && (
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    onPrevious?.()
                    setActiveTab(activeTab - 1)
                  }}
                >
                  Previous
                </Button>
              )}
              {(activeTab !== 2 || selectedPaymentProvider !== "paypal") && (
                <Button
                  type="primary"
                  loading={paymentLoading}
                  disabled={paymentLoading || isNextDisabled || (mode && loggedIn && !selectedPaymentMethodId && activeTab === 2)}
                  onClick={() => {
                    onNext()
                  }}
                >
                  {activeTab === 2 ? "Submit" : "Next"}
                </Button>
              )}
            </Flex>
          )}
        </Flex>
      </footer>
    </Container>
  )
}

export default EmbeddedBookingLayout

EmbeddedBookingLayout.propTypes = {
  children: PropTypes.node.isRequired,
  setActiveTab: PropTypes.func,
  activeTab: PropTypes.number,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  type: PropTypes.string,
  mode: PropTypes.string,
  selectedPaymentProvider: PropTypes.string,
  isNextDisabled: PropTypes.bool,
  paymentLoading: PropTypes.bool
}
